__turbopack_context__.v({
  "child": "style-module-scss-module__cGSJpW__child",
  "clear-button": "style-module-scss-module__cGSJpW__clear-button",
  "drop-button": "style-module-scss-module__cGSJpW__drop-button",
  "drop-option": "style-module-scss-module__cGSJpW__drop-option",
  "dropdown-content": "style-module-scss-module__cGSJpW__dropdown-content",
  "has-query": "style-module-scss-module__cGSJpW__has-query",
  "input-wrapper": "style-module-scss-module__cGSJpW__input-wrapper",
  "is-commercial": "style-module-scss-module__cGSJpW__is-commercial",
});
